// Pre-rendered landing pages (scripts/prerender-start.mjs) ship a static copy of the page in
// #prerender-snapshot so the hero paints before the JavaScript bundle runs. When the live React
// page mounts it calls releasePrerender(), which removes the static copy and shows #root in the
// same frame. index.html-based pages have no snapshot, so this is a no-op there.
export function releasePrerender() {
  if (typeof document === 'undefined') return;
  const snap = document.getElementById('prerender-snapshot');
  if (snap && snap.parentNode) snap.parentNode.removeChild(snap);
  document.documentElement.classList.remove('has-prerender');
}
